module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="dd-handle"><input type="text" value="'+
((__t=(view.model.get('name')))==null?'':_.escape(__t))+
'" /></div>\n<ol class="dd-list"></ol>';
}
return __p;
};